import {LOOK_ROOM_TYPES} from "../bvcomponents/look/core/constants";
import {getCommonVisualizerType, IS_LIXIL_SERVERS} from "../config";

/**
 * @param preset {object} visualizer management preset
 * @param forVisualizerType {string} visualizer type
 * @return {object} visualizer management preset
 */
export const updatePresetRoomLayout = (preset, forVisualizerType = document.kvConfig.visualizerType) => {
  if (!preset.lookId) {
    preset.lookId = 0;
  }
  if ((forVisualizerType === "bvLook") && IS_LIXIL_SERVERS) {
    if (preset.roomType === LOOK_ROOM_TYPES.as) {
      preset.layout_type = preset.layout_type > 20
        ? preset.layout_type - 10
        : preset.layout_type < 10
          ? preset.layout_type + 10
          : preset.layout_type;
    } else {
      preset.layout_type = preset.layout_type >= 10
        ? preset.layout_type - 10
        : preset.layout_type;
    }
  }
  return preset
}

export const updatePresetsArray = (responseDefaults, forVisualizerType) => {
  let bvPresets = JSON.parse(responseDefaults) || [];
  const noPresetsAtAll = bvPresets.every(preset => !preset.id);
  return bvPresets.map((preset, presetIndex) => {
    if (noPresetsAtAll) {
      preset.id = presetIndex + 1;
    } else if (!Number.isInteger(preset.id)) {
      preset.id = presetIndex + 100 // 100 is to make id's really unique
    }
    preset = updatePresetRoomLayout(preset, forVisualizerType);
    return preset
  });
}

/**
 * returns the key used in bathroomVisualizerState.loadedPresets, e.g. "kitchen-1", "bathroom-2",
 * so preset ids don't intersect across different visualizer types
 * @param presetId {number|string}
 * @param visualizerType {string} defaults to the current visualizer type
 * @return {string}
 */
export const getLoadedPresetKey = (presetId, visualizerType) => {
  return `${getCommonVisualizerType(visualizerType)}-${presetId}`
}
